import i18next from 'i18next';

import { confirmDeletion } from '@vlabs/monokit/shared/ui/confirm-deletion';

interface ConfirmDeleteSourceGroupProps {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
}

export function confirmDeleteSourceGroup({
  onConfirm,
  onReject,
}: ConfirmDeleteSourceGroupProps): void {
  confirmDeletion({
    cancelLabel: i18next.t('features:deleteSourceGroup.confirmation.buttons.cancel'),
    confirmLabel: i18next.t('features:deleteSourceGroup.confirmation.buttons.delete'),
    onConfirm,
    onReject,
    subtitle: i18next.t('features:deleteSourceGroup.confirmation.subtitle'),
    title: i18next.t('features:deleteSourceGroup.confirmation.title'),
  });
}
